
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tribute",
      function () {
        return require("private-next-pages/tribute/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tribute"])
      });
    }
  